'use client';

import cx from 'classnames';
import { testDriveCenterImages } from '~/constants/dealership/testDriveCenter/assets';
import optimizeImage from '~/utilities/optimizeImage';
import useHaloParallax from '../hooks/useHaloParallax';
import styles from '../TestDriveCenter.module.css';

const haloImage = optimizeImage(testDriveCenterImages.haloJeep, {
  format: 'auto',
  optimize: 'medium'
});

export default function TestDriveCenterProductReveal() {
  const haloRef = useHaloParallax<HTMLImageElement>();

  return (
    <section
      className={cx(
        styles.reveal,
        'relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-[clamp(20px,4vw,56px)] py-[clamp(72px,9vh,120px)] text-center'
      )}
    >
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 h-[min(1100px,120vw)] w-[min(1100px,120vw)] -translate-x-1/2 -translate-y-1/2 rounded-full border-[1.5px] border-[#dbe6f2]"
      />
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 h-[min(720px,86vw)] w-[min(720px,86vw)] -translate-x-1/2 -translate-y-1/2 rounded-full border-[1.5px] border-[#e4edf6]"
      />
      <div className={cx(styles.eyebrow, styles.revealEyebrow, styles.animIn)}>
        Chrysler · Dodge · Jeep · Ram
      </div>
      <h2
        className={cx(
          styles.animIn,
          'relative z-[2] mb-8 max-w-[13ch] font-[family-name:var(--font-display)] text-[clamp(40px,6.6vw,104px)] font-black uppercase leading-[0.9] tracking-[-0.02em] text-[var(--cvna-navy-ink)]'
        )}
      >
        Every car, halo-new
      </h2>
      <p
        className={cx(
          styles.animIn,
          'relative z-[2] mt-[14px] max-w-[480px] text-[clamp(16px,1.5vw,20px)] font-normal leading-[1.55] text-[var(--cvna-slate)]'
        )}
      >
        Drive any brand-new Jeep, Dodge, Ram, or Chrysler on the lot. As many as
        you like, in a single&nbsp;visit.
      </p>
      <div
        className={cx(
          styles.haloWrap,
          'relative z-[1] mb-[-2vh] mt-[clamp(6px,2vh,28px)] w-[min(960px,108vw)]'
        )}
      >
        <img
          ref={haloRef}
          alt="A brand-new Jeep Grand Cherokee with the Carvana golden halo"
          className={cx(
            styles.haloImg,
            'block h-auto w-full will-change-transform'
          )}
          src={haloImage}
        />
      </div>
    </section>
  );
}
